// Author Liang Gangqiang
// Date 2025-01-23 14:44:58

class SithMesNcrProcessTask {
    constructor({
                    id = null,
                    status = '',
                    workOrderCode = '',
                    projectCode = '',
                    objectId = '',
                    objectType = '',
                    causedBy = '',
                    ncrDescription = '',
                    solutionCode = '',
                    wbsNumber = '',
                    ncr_count = '',
                    NCR_Comments = '',
                    material_num = '',
                    recoverNcc = '',
                    recoverNccRemark = '',
                    ppHeaderId = '',
                    ncc = '',
                    supplier = '',
                    supplierNum = '',
                    technicalOff = '',
                    technicalOffTime = '',
                    actualOff = '',
                    actualOffTime = '',
                    need8dAnalysis = '',
                    remark = '',
                    poNumber = '',
                    poItem = '',
                    materialFrom = '',
                    materialFromName = '',
                    purchaser = '',
                    taskAttachment = '',
                    taskAttachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.status = status;
        this.workOrderCode = workOrderCode;
        this.projectCode = projectCode;
        this.objectId = objectId;
        this.objectType = objectType;
        this.causedBy = causedBy;
        this.ncrDescription = ncrDescription;
        this.solutionCode = solutionCode;
        this.wbsNumber = wbsNumber;
        this.ncr_count = ncr_count;
        this.NCR_Comments = NCR_Comments;
        this.material_num = material_num;
        this.recoverNcc = recoverNcc;
        this.recoverNccRemark = recoverNccRemark;
        this.ppHeaderId = ppHeaderId;
        this.ncc = ncc;
        this.supplier = supplier;
        this.supplierNum = supplierNum;
        this.technicalOff = technicalOff;
        this.technicalOffTime = technicalOffTime;
        this.actualOff = actualOff;
        this.actualOffTime = actualOffTime;
        this.need8dAnalysis = need8dAnalysis;
        this.remark = remark;
        this.poNumber = poNumber;
        this.poItem = poItem;
        this.materialFrom = materialFrom;
        this.materialFromName = materialFromName;
        this.purchaser = purchaser;
        this.taskAttachment = taskAttachment;
        this.taskAttachmentList = taskAttachmentList;
    }
}

function newEntity() {
    return new SithMesNcrProcessTask();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'workOrderCode',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.workOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'objectTypeName',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.objectTypeName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdByName',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.createdByName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'causedBy',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.causedBy',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ncrDescription',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.ncrDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'solutionName',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.solutionName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsNumber',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.wbsNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ncr_count',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.ncr_count',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'NCR_Comments',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.NCR_Comments',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialFrom',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.materialFrom',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialFromName',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.materialFromName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poNumber',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.poNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItem',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.poItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaser',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.purchaser',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'material_num',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.material_num',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'recoverNcc',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.recoverNcc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'recoverNccRemark',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.recoverNccRemark',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ppHeaderId',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.ppHeaderId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ncc',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.ncc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'supplier',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.supplier',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'supplierNum',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.supplierNum',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'technicalOff',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.technicalOff',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'technicalOffTime',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.technicalOffTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualOff',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.actualOff',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualOffTime',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.actualOffTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'need8dAnalysis',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.need8dAnalysis',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'taskAttachmentList',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.taskAttachmentList',
            sortable: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'statusName',
            label: 'label.sith.quality.sithMesNcrProcessTask.grid.statusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
    ])
}

const sithMesNcrProcessTaskProcessVoConfigs = [
    {
        key: 'workOrderCode',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.workOrderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectTypeName',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.objectTypeName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTime',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.createdTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByName',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.createdByName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'causedBy',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.causedBy',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFrom',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.materialFrom',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFromName',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.materialFromName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.orderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationSeq',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.operationSeq',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderCode',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.purchaseOrderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItem',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.poItem',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supplier',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.supplier',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supplierNum',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.supplierNum',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaser',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.purchaser',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'solutionName',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.solutionName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.wbsNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncr_count',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.ncr_count',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'NCR_Comments',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.NCR_Comments',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material_num',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.material_num',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'recoverNcc',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.recoverNcc',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'recoverNccRemark',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.recoverNccRemark',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderId',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.ppHeaderId',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncc',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.ncc',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'technicalOff',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.technicalOff',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'technicalOffTime',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.technicalOffTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualOff',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.actualOff',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualOffTime',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.actualOffTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'need8dAnalysis',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.need8dAnalysis',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.remark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusName',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.statusName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrDescription',
        label: 'label.sith.quality.sithMesNcrProcessTaskProcess.grid.ncrDescription',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
]

const filter = {
    idFilter: '',
    idListFilter: [],
    statusFilter: '',
    workOrderCodeFilter: '',
    projectCodeFilter: '',
    objectIdFilter: '',
    objectTypeFilter: '',
    createdTimeFilter: '',
    causedByFilter: '',
    ncrDescriptionFilter: '',
    solutionCodeFilter: '',
    wbsNumberFilter: '',
    ncr_countFilter: '',
    ncr_commentsFilter: '',
    material_numFilter: '',
    recoverNccFilter: '',
    recoverNccRemarkFilter: '',
    ppHeaderIdFilter: '',
    nccFilter: '',
    supplierFilter: '',
    supplierNumFilter: '',
    technicalOffFilter: '',
    technicalOffTimeRteFilter: '',
    technicalOffTimeLteFilter: '',
    actualOffFilter: '',
    actualOffTimeRteFilter: '',
    actualOffTimeLteFilter: '',
    need8dAnalysisFilter: '',
    poNumberFilter: '',
    poItemFilter: '',
    materialFromFilter: '',
    materialFromNameFilter: '',
    purchaserFilter: '',
    createdByNameFilter: '',
    userGroupIdFilter: '',
    workflowQueryTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'statusFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emActProcessStatus'
            , showLabelSelectOne: true
            , selectFilter: {processBusinessEntityFilter: 'SithMesNcrProcessTask', statusFilter: 1}
        }
    },
    {
        key: 'workOrderCodeFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.workOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectIdFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.objectId',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectTypeFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.objectType',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesQualityInspectType'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'createdTimeFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.createdTime',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'causedByFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.causedBy',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrDescriptionFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.ncrDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'solutionCodeFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.solutionCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumberFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.wbsNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncr_countFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.ncr_count',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncr_commentsFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.NCR_Comments',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material_numFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.material_num',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'recoverNccFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.recoverNcc',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'recoverNccRemarkFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.recoverNccRemark',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderIdFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.ppHeaderId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'nccFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.ncc',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supplierFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.supplier',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supplierNumFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.supplierNum',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'technicalOffFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.technicalOff',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'technicalOffTimeRteFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.technicalOffTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'technicalOffTimeLteFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.technicalOffTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualOffFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.actualOff',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualOffTimeRteFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.actualOffTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualOffTimeLteFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.actualOffTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'need8dAnalysisFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.need8dAnalysis',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumberFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.poNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.poItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFromFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.materialFrom',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFromNameFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.materialFromName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.purchaser',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.quality.sithMesNcrProcessTask.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectId',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.objectId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectType',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.objectType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'causedBy',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.causedBy',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrDescription',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.ncrDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'solutionCode',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.solutionCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.wbsNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncr_count',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.ncr_count',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'NCR_Comments',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.NCR_Comments',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material_num',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.material_num',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'recoverNcc',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.recoverNcc',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'recoverNccRemark',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.recoverNccRemark',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderId',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.ppHeaderId',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncc',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.ncc',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supplier',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.supplier',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'technicalOff',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.technicalOff',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'technicalOffTime',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.technicalOffTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualOff',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.actualOff',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualOffTime',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.actualOffTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'need8dAnalysis',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.need8dAnalysis',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumber',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.poNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItem',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.poItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFrom',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.materialFrom',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFromName',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.materialFromName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaser',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.purchaser',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskAttachmentList',
        label: 'label.sith.quality.sithMesNcrProcessTask.entity.taskAttachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'taskAttachment'
        }
    }
]

export {
    SithMesNcrProcessTask, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs

    , sithMesNcrProcessTaskProcessVoConfigs
}
